import { apiRequest } from './api';
import { ApiResponse, AtendimentoSetor } from '../types';

export interface AtendimentoSetorCreateData {
  parent_id?: number | null;
  nome: string;
  descricao?: string | null;
  cor?: string;
  icone?: string | null;
  usuarios?: number[];
  ordem?: number;
  ativo?: boolean;
}

export interface AtendimentoSetorUpdateData extends Partial<AtendimentoSetorCreateData> {}

class AtendimentoSetorService {
  private baseUrl = '/atendimento-setores';

  async getAll(params: { search?: string; ativo?: boolean } = {}): Promise<ApiResponse<AtendimentoSetor[]>> {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.ativo !== undefined) queryParams.append('ativo', String(params.ativo));

    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest.get<AtendimentoSetor[]>(`${this.baseUrl}${queryString}`);
  }

  async create(data: AtendimentoSetorCreateData): Promise<AtendimentoSetor> {
    const response = await apiRequest.post<AtendimentoSetor>(this.baseUrl, data);
    if (!response.data) throw new Error('Falha ao criar setor');
    return response.data;
  }

  async update(id: number, data: AtendimentoSetorUpdateData): Promise<AtendimentoSetor> {
    const response = await apiRequest.put<AtendimentoSetor>(`${this.baseUrl}/${id}`, data);
    if (!response.data) throw new Error('Falha ao atualizar setor');
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await apiRequest.delete(`${this.baseUrl}/${id}`);
  }
}

export const atendimentoSetorService = new AtendimentoSetorService();
export default atendimentoSetorService;
